module.exports = __webpack_public_path__ + "static/img/personal.797194a6.png";